import React from 'react';
import cx from 'classnames';
import EventLabel from '../../components/EventLabel/EventLabel';
import { Sorter } from './types';

interface ITableHeaderProps {
  onSort: (sortColumn: any) => void;
  desc: boolean;
  sortBy: string;
}

export default function TableHeader({ desc, sortBy, onSort }: ITableHeaderProps) {
  return (
    <div className="hidden lg:grid grid-cols-12 gap-2 py-2 pl-3  bg-neutral-50 border-y  text-sm text-neutral-600 border-divider">
      <div className="col-span-5 lg:col-span-3 text-left px-4 cursor-pointer" onMouseDown={() => onSort(Sorter.TIME)}>
        <EventLabel name="TimeCol" groupName="CMS.MatchMaking" />
        <span>{sortBy === Sorter.TIME && desc ? <i className={cx('ri-arrow-up-s-fill')} /> : <i className={cx('ri-arrow-down-s-fill')} />}</span>
      </div>
      <div className="col-span-4 lg:col-span-6 text-left  cursor-pointer" onMouseDown={() => onSort(Sorter.NAME)}>
        <EventLabel name="NameCol" groupName="CMS.MatchMaking" />
        <span>{sortBy === Sorter.NAME && desc ? <i className={cx('ri-arrow-up-s-fill')} /> : <i className={cx('ri-arrow-down-s-fill')} />}</span>
      </div>
      <div className="col-span-3 text-center  hidden md:flex cursor-pointer" onMouseDown={() => onSort(Sorter.STATUS)}>
        <EventLabel name="StatusCol" groupName="CMS.MatchMaking" />
        <span>{sortBy === Sorter.STATUS && desc ? <i className={cx('ri-arrow-up-s-fill')} /> : <i className={cx('ri-arrow-down-s-fill')} />}</span>
      </div>
    </div>
  );
}
